import React from 'react';
import AnimeCard from './AnimeCard';
import './AnimeCard.css';

const AnimeCardsGrid = ({ animes, layout = "horizontal" }) => {
  // Add validation for the animes prop
  if (!animes || !Array.isArray(animes)) {
    console.error("Invalid animes array provided to AnimeCardsGrid:", animes);
    return (
      <div className="anime-cards-grid">
        <div className="no-data-card">No anime data available</div>
      </div>
    );
  }

  // Debug info to see what's in the array
  console.log(`AnimeCardsGrid received ${animes.length} anime items`);
  if (animes.length > 0) {
    console.log("First anime item:", animes[0]);
  }

  return (
    <div className="anime-cards-grid">
      {animes.map((anime, index) => {
        // Check if anime has an id, if not, use the index as a fallback key
        const key = anime && anime.id ? anime.id : `anime-item-${index}`;
        return <AnimeCard key={key} anime={anime} layout={layout} />;
      })}
    </div>
  );
};

export default AnimeCardsGrid;